/* eslint-disable multiline-ternary */
/* eslint-disable comma-dangle */
/* eslint-disable semi */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../configs/apiConfig";
import axios from "axios";
export const fetchUsers = createAsyncThunk(
  "users/fetchAll",
  async (filter, { rejectWithValue }) => {
    try {
      const adminToken = localStorage.getItem("adminToken");
      if (!adminToken) {
        return rejectWithValue("Authentication token not found.");
      }
      const response = await axios.get(
        filter
          ? `${API_URL}/admin/users/search?${filter}`
          : `${API_URL}/admin/users`,
        {
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
const initialState = {
  users: [],
  error: null,
  loading: false,
};
const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default usersSlice.reducer;
